require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-16-important-e-commerce-shopping-dates-for-your-2019-diary.json") })
        }
      }, "path---blog-16-important-e-commerce-shopping-dates-for-your-2019-diary");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-16-important-e-commerce-shopping-dates-for-your-2019-diary!./.cache/json/blog-16-important-e-commerce-shopping-dates-for-your-2019-diary.json
// module id = 385
// module chunks = 231608221292675